var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _circle, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 102,
    viewBox: "0 0 180 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 102,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 57.113H68.7347V42.5H66V57.113Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2042 55.2754C82.7013 56.7574 80.7598 57.4464 78.6511 57.4464C73.2233 57.4464 70.927 53.7096 70.9064 49.9105C70.8856 46.0903 73.3695 42.207 78.6511 42.207C80.6344 42.207 82.5135 42.9585 84.0166 44.4408L82.1792 46.2153C81.2191 45.2762 79.925 44.8377 78.6511 44.8377C75.1233 44.8377 73.5993 47.468 73.6204 49.9105C73.641 52.3322 75.0399 54.8582 78.6511 54.8582C79.925 54.8582 81.3651 54.3363 82.3256 53.376L84.2042 55.2754Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2969 50.2867H92.4304C95.9581 50.2867 95.9375 45.1094 92.4304 45.1094H88.2969V50.2867ZM92.4321 52.814H88.2986V57.1143H85.543V42.5013C87.8395 42.5013 90.1358 42.4805 92.4321 42.4805C99.5716 42.4805 99.5924 52.814 92.4321 52.814Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.677 46.0293C108.177 45.194 106.798 44.4009 105.212 44.4009C103.166 44.4009 102.185 45.2566 102.185 46.3424C102.185 47.6157 103.688 47.9708 105.442 48.1796C108.49 48.5554 111.329 49.3483 111.329 52.8345C111.329 56.0913 108.447 57.4901 105.191 57.4901C102.206 57.4901 99.9093 56.5718 98.8242 53.8995L101.12 52.7095C101.767 54.3167 103.458 55.0268 105.233 55.0268C106.965 55.0268 108.594 54.4213 108.594 52.8345C108.594 51.457 107.153 50.8931 105.212 50.6843C102.226 50.3297 99.471 49.5364 99.471 46.2589C99.471 43.2525 102.435 42.0212 105.128 42C107.404 42 109.763 42.6473 110.87 44.9015L108.677 46.0293Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.521 46.8008L124.776 54.5455L127.135 46.8008H129.953L126.362 57.1555H123.398L122.333 54.1077L121.415 50.6629L120.496 54.1077L119.432 57.1555H116.467L112.855 46.8008H115.695L118.054 54.5455L120.288 46.8008H122.521Z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.404 55.0619C133.796 55.0619 132.488 53.7538 132.488 52.146C132.488 50.5386 133.796 49.2305 135.404 49.2305C137.012 49.2305 138.32 50.5386 138.32 52.146C138.32 53.7538 137.012 55.0619 135.404 55.0619ZM138.347 47.5598C137.466 46.9939 136.451 46.6953 135.405 46.6953C132.399 46.6953 129.953 49.1411 129.953 52.1468C129.953 55.1528 132.399 57.5984 135.405 57.5984C136.451 57.5984 137.466 57.2998 138.347 56.7339V57.388H140.856V46.8846H138.347V47.5598Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39515_29908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 46,
    width: 12,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.555 46.6836H153.935V61.5185H142.555V46.6836Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39515_29908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.482 55.05C146.875 55.05 145.566 53.742 145.566 52.1343C145.566 50.5267 146.875 49.2188 148.482 49.2188C150.09 49.2188 151.398 50.5267 151.398 52.1343C151.398 53.742 150.09 55.05 148.482 55.05ZM148.483 46.6836C147.242 46.6836 146.032 47.1128 145.064 47.8948V46.9354H142.555V61.5185H145.064V56.3755C146.032 57.1575 147.242 57.5867 148.483 57.5867C151.489 57.5867 153.935 55.1409 153.935 52.135C153.935 49.1294 151.489 46.6836 148.483 46.6836Z",
    fill: "#262626"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 51,
    r: 16,
    fill: "url(#paint0_linear_39515_29908)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1773 42.0391C43.6017 42.0391 41.7412 44.0994 41.245 45.5543C40.3745 47.793 40.742 49.5127 41.0658 51.0292L41.0893 51.1397C41.39 52.5501 41.6737 53.8822 41.2674 55.5542C41.2296 55.7831 41.1626 56.0082 41.0681 56.2233C40.6031 57.2895 39.5487 57.9781 38.3822 57.9781C36.7677 57.9781 35.4541 56.6724 35.4541 55.0671C35.4541 53.4612 36.7677 52.1547 38.3822 52.1547C38.817 52.1547 39.2349 52.2479 39.625 52.4311L39.9651 52.5912L39.5414 50.0161L39.4077 49.9892C39.0722 49.9221 38.7272 49.8883 38.3822 49.8883C35.5113 49.8883 33.1758 52.2114 33.1758 55.0671C33.1758 57.923 35.5113 60.246 38.3822 60.246C40.7655 60.246 42.8396 58.6431 43.4229 56.361C44.0127 54.5736 43.737 52.9428 43.3462 51.148L43.3025 50.9483C42.919 49.193 42.616 47.8065 43.5296 45.9757C44.0104 44.9619 45.0496 44.3066 46.1773 44.3066C47.7912 44.3066 49.1043 45.6122 49.1043 47.2175C49.1043 48.8226 47.7912 50.1288 46.1773 50.1288C45.7773 50.1288 45.3886 50.0498 45.0211 49.8933L44.6908 49.753L45.108 52.2888L45.2452 52.3138C45.5502 52.3686 45.8639 52.3967 46.1773 52.3967C49.0476 52.3967 51.3827 50.0732 51.3827 47.2175C51.3827 44.3621 49.0476 42.0391 46.1773 42.0391Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39515_29908",
    x1: 25.7355,
    y1: 50.1351,
    x2: 55.2813,
    y2: 49.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5569DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8572FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.dcc516b1ddad8ffe1806f859848eb1df.svg";
export { ForwardRef as ReactComponent };